import React from 'react';
import { map } from 'lodash/fp';
import { pluralize } from 'utils/string_utils';
import Comment from './Comment';

class CommentList extends React.Component {
  constructor(props) {
    super(props);
    this.state = { collapsed: true };
  }

  static defaultProps = {
    maxCollapsedComments: 3,
    collapseAtIndex: 2,
  };

  get shouldCollapse() {
    const { comments, maxCollapsedComments } = this.props;
    return this.state.collapsed && comments.length > maxCollapsedComments;
  }

  renderExpander() {
    const { comments, maxCollapsedComments } = this.props;
    const count = comments.length - maxCollapsedComments;
    return (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events
      <div
        className="CommentList-expand"
        onClick={() => this.setState({ collapsed: false })}
        children={`${count} more ${pluralize(count, 'reply', 'replies')}`}
        key="expander"
      />
    );
  }

  renderList() {
    const { collapseAtIndex, comments } = this.props;
    const renderComments = map(props => <Comment key={props.id} {...props} />);
    if (this.shouldCollapse)
      return [
        renderComments(comments.slice(0, collapseAtIndex)),
        this.renderExpander(),
        renderComments(comments.slice(-1)),
      ];
    return renderComments(comments);
  }

  render() {
    return <div className="CommentList" children={this.renderList()} />;
  }
}

export default CommentList;
